import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { ActionButtonComponent, ListFilterComponent, SvgIconComponent } from '../../ui-kit';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxsModule } from '@ngxs/store';
import { PartnerListState } from '../../store/state/administration/partner';
import { DirectivesModule } from '../../common/directives/directives.module';
import { PipesModule } from '../../common';
import { RolesSelectionComponent } from './role-selection.component';
import { RolesSelectionDialogComponent } from './role-selection-dialog/role-selection-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatChipsModule,
    MatTableModule,
    MatPaginatorModule,
    ListFilterComponent,
    MatCheckboxModule,
    ActionButtonComponent,
    MatDialogModule,
    RouterModule,
    NgxsModule.forFeature([PartnerListState]),
    TranslateModule.forChild({}),
    DirectivesModule,
    PipesModule,
    SvgIconComponent,
  ],
  exports: [RolesSelectionComponent, RolesSelectionDialogComponent],
  declarations: [RolesSelectionComponent, RolesSelectionDialogComponent],
})
export class RolesSelectionModule {}
